import { nextExerciseDetailsActionTypes } from './Constants';

export function getQuestionExplanation(questionId, source, exerciseId, userAnswers, isPreview) {
	return {
		type: nextExerciseDetailsActionTypes.GET_QUESTION_EXPLANATION,
		payload: {
			questionId,
			source,
			exerciseId,
			userAnswers,
			isPreview,
		},
	};
}

export function getQuestionExplanationSuccess(explanation) {
	return {
		type: nextExerciseDetailsActionTypes.GET_QUESTION_EXPLANATION_SUCCESS,
		payload: {
			explanation,
		},
	};
}

export function getQuestionExplanationError() {
	return {
		type: nextExerciseDetailsActionTypes.GET_QUESTION_EXPLANATION_ERROR,
	};
}

export function getTopicExplanation(topicId, streamId) {
	return {
		type: nextExerciseDetailsActionTypes.GET_TOPIC_EXPLANATION,
		payload: {
			topicId,
			streamId,
		},
	};
}

export function getTopicExplanationSuccess(data) {
	return {
		type: nextExerciseDetailsActionTypes.GET_TOPIC_EXPLANATION_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getTopicExplanationError() {
	return {
		type: nextExerciseDetailsActionTypes.GET_TOPIC_EXPLANATION_ERROR,
	};
}

export function clearState() {
	return {
		type: nextExerciseDetailsActionTypes.CLEAR_STATE,
	};
}

export function createExerciseRequest(createData, restartId, callback) {
	return {
		type: nextExerciseDetailsActionTypes.CREATE_EXERCISE,
		payload: {
			createData,
			restartId,
			callback,
		},
	};
}

export function createExerciseSuccess(data) {
	return {
		type: nextExerciseDetailsActionTypes.CREATE_EXERCISE_SUCCESS,
		payload: {
			data,
		},
	};
}

export function createExerciseError() {
	return {
		type: nextExerciseDetailsActionTypes.CREATE_EXERCISE_ERROR,
	};
}

export function setExerciseScore(correctCount, incorrectCount, wordsToGo) {
	return {
		type: nextExerciseDetailsActionTypes.SET_EXERCISE_SCORE,
		payload: {
			correctCount,
			incorrectCount,
			wordsToGo,
		},
	};
}

export function resumeExerciseRequest(data) {
	return {
		type: nextExerciseDetailsActionTypes.RESUME_EXERCISE_REQUEST,
		payload: data,
	};
}

export function resumeExerciseError() {
	return {
		type: nextExerciseDetailsActionTypes.RESUME_EXERCISE_ERROR,
	};
}

export function sendAnswerRequest(data, code) {
	return {
		type: nextExerciseDetailsActionTypes.SEND_QUESTION_ANSWER_REQUEST,
		payload: {
			data,
			code,
		},
	};
}

export function sendAnswerSuccess(data) {
	return {
		type: nextExerciseDetailsActionTypes.SEND_QUESTION_ANSWER_SUCCESS,
		payload: { data },
	};
}

export function sendAnswerError() {
	return {
		type: nextExerciseDetailsActionTypes.SEND_QUESTION_ANSWER_ERROR,
	};
}

export function stopTestRequest(data) {
	return {
		type: nextExerciseDetailsActionTypes.STOP_TEST,
		payload: data,
	};
}

export function stopTestRequestError() {
	return {
		type: nextExerciseDetailsActionTypes.STOP_TEST_ERROR,
	};
}

export function storeTime(data) {
	return {
		type: nextExerciseDetailsActionTypes.STORE_TIME,
		payload: data,
	};
}

export function storeTimeBetween(data) {
	return {
		type: nextExerciseDetailsActionTypes.STORE_TIME_BETWEEN,
		payload: data,
	};
}

export function setFinishExercise() {
	return {
		type: nextExerciseDetailsActionTypes.SET_FINISH_EXERCISE,
	};
}

export function handleNextExerciseTypes(exerciseType) {
	return {
		type: nextExerciseDetailsActionTypes.HANDLE_NEXT_EXERCISE_TYPES,
		payload: {
			exerciseType,
		},
	};
}

export function checkWordsByTypo(wordTuples) {
	return {
		type: nextExerciseDetailsActionTypes.CHECK_WORDS_BY_TYPO,
		payload: {
			wordTuples,
		},
	};
}

export function checkWordsByTypoSuccess(wordTuples) {
	return {
		type: nextExerciseDetailsActionTypes.CHECK_WORDS_BY_TYPO_SUCCESS,
		payload: {
			wordTuples,
		},
	};
}

export function getAdditionalExplanationRequest(questionId, previousExplanations) {
	return {
		type: nextExerciseDetailsActionTypes.GET_ADDITIONAL_EXPLANATION_REQUEST,
		payload: {
			questionId,
			previousExplanations,
		},
	};
}

export function getAdditionalExplanationSuccess(newExplanation) {
	return {
		type: nextExerciseDetailsActionTypes.GET_ADDITIONAL_EXPLANATION_SUCCESS,
		payload: {
			newExplanation,
		},
	};
}

export function checkAnswer(exerciseId, questionId, userAnswer, expectedAnswer) {
	return {
		type: nextExerciseDetailsActionTypes.CHECK_ANSWER_REQUEST,
		payload: {
			exerciseId,
			questionId,
			userAnswer,
			expectedAnswer,
		},
	};
}

export function checkAnswerSuccess(answerData) {
	return {
		type: nextExerciseDetailsActionTypes.CHECK_ANSWER_SUCCESS,
		payload: {
			answerData,
		},
	};
}

export function checkAnswerError() {
	return {
		type: nextExerciseDetailsActionTypes.CHECK_ANSWER_ERROR,
	};
}

export function personalizedQuestion(exerciseId, questionId, interests, question, expectedAnswer) {
	return {
		type: nextExerciseDetailsActionTypes.PERSONALIZED_QUESTION_REQUEST,
		payload: {
			exerciseId,
			interests,
			question,
			expectedAnswer,
			questionId,
		},
	};
}

export function personalizedQuestionSuccess(personalizedQuestionData) {
	return {
		type: nextExerciseDetailsActionTypes.PERSONALIZED_QUESTION_SUCCESS,
		payload: {
			personalizedQuestionData,
		},
	};
}

export function personalizedQuestionError() {
	return {
		type: nextExerciseDetailsActionTypes.PERSONALIZED_QUESTION_ERROR,
	};
}

export function getAiExplanationRequest(exerciseId, questionId, userAnswer) {
	return {
		type: nextExerciseDetailsActionTypes.GET_AI_EXPLANATION_REQUEST,
		payload: {
			exerciseId,
			questionId,
			userAnswer,
		},
	};
}

export function getAiExplanationSuccess(requestId, aiExplanation) {
	return {
		type: nextExerciseDetailsActionTypes.GET_AI_EXPLANATION_SUCCESS,
		payload: {
			requestId,
			aiExplanation,
		},
	};
}

export function getAiExplanationError() {
	return {
		type: nextExerciseDetailsActionTypes.GET_AI_EXPLANATION_ERROR,
	};
}

export function setRequestId(requestId) {
	return {
		type: nextExerciseDetailsActionTypes.SET_REQUEST_ID,
		payload: {
			requestId,
		},
	};
}
